enum OhsCorrespondenceTemplateContendType {
  OhsRichText = 'text/html',

  OhsAttachment = 'application/vnd.safetychampion.attachment',
}

export default OhsCorrespondenceTemplateContendType;
